var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex flex-column ",attrs:{"id":"app"}},[_c('Navbar'),_c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('router-view')],1),_c('div',{staticClass:"row"},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }